// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"142":"a7c0dd09","618":"a7cbd657"}[chunkId] + ".chunk.js");